<template>
    <div class="min-h-44px">
        <div :class="classLabel">
            {{ label }}
        </div>
         <div :class="classContent">
            {{ content }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'LabelContent',
    props:{
        label:{
            type:String,
            default: ''
        },
        content:{
            type:String,
            default: ''
        },
        classLabel:{
            type:String,
            default: 'text-tc-gray-3 text-18'
        },
        classContent:{
            type:String,
            default: 'text-tc-blue-1 text-20'
        }
    },

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>

</style>
